import React, { useContext } from 'react';
import './Type3.scss';
import intl from 'react-intl-universal';
import { getGalleryStatus } from '../../utils/util';
import { IGalleryType, IGalleryData, IGalleryList } from './GalleryType';
import { inject, observer } from 'mobx-react';
import Lock from './Lock';
import StatisticsRow from '../StatisticsRow';
import StatusTag from '../Tag/StatusTag';
import classNames from 'classnames';
import { IGalleryStatus, IViewDetail } from '../../global.d';
import { direct, style } from '../../utils/image';
import { navigatorTo } from '../../utils/util';
import { ThemeContext } from '../../store/ThemeProvider';
import uImageCount from './useImageCount';
import { getPendantColor } from '../../utils/color';

// 这是原来的type3
interface IType3 extends IGalleryType {
  desc?: string;
}
const Type3 = (props: IType3) => {
  const {
    image,
    link,
    gallerys = {} as IGalleryList,
    info = true,
    total = true,
    showname = true,
    namealign = 'left',
    imageadjust = false,
    desc
  } = props;

  const loc = intl.getInitOptions().currentLocale;

  const { view_detail, image_total, gallery } =
    ['subgallery', 'gallery'].indexOf(link.type) > -1
      ? uImageCount(link, gallerys)
      : {
          view_detail: null,
          image_total: 0,
          gallery: {
            name: desc,
            status: '',
            start_time: '',
            end_time: '',
            is_pay_down: 0
          }
        };

  // const [statusName, statusColor] = gallery ? getGalleryStatus(gallery.status as IGalleryStatus) : ['', ''];
  const cns = classNames('type-wrapper type3-wrapper', props.className, !!imageadjust && 'imageadjust');

  const { h2Color, backgroundColor } = useContext(ThemeContext);
  let [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor, true);
  return (
    <div
      className={cns}
      style={props.style}
      onClick={() => {
        props.onClick(link);
      }}
    >
      <div className="main">
        <div
          className="content"
          style={
            {
              // backgroundImage: `url('${}')`,
              // backgroundSize: '100% 100%'
            }
          }
        >
          <img
            className="content-img"
            src={style(image, props.imageStyle || 'wx_gallery_mode_3') || ''}
          />
          {gallery && Number(gallery.is_pay_down) ? <StatusTag
            status={IGalleryStatus.needpay}
            className={'status pay-status'}
            fontSize={12}
          /> : null}
          <div className="content-one">
            {info ? (
              <StatusTag
                status={(gallery || {}).status as IGalleryStatus}
                className={'status'}
                startTime={(gallery || ({} as IGalleryData)).start_time}
                endTime={(gallery || ({} as IGalleryData)).end_time}
              />
            ) : null}
            {!!view_detail && total ? (
              <div
                className={'bottom-row'}
                style={{ backgroundColor: pendantBgColor }}
              >
                <StatisticsRow
                  n1={image_total}
                  n2={view_detail.view || 0}
                  fontColor={pendantIconColor}
                />
              </div>
            ) : null}
            {/*<Lock />*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Type3;
